import { CheckOutlined, CloseOutlined } from "@ant-design/icons";

/**
 * PASS, FAIL, PENDING or N/A as a soft chip with its mark (the 4.0 report's),
 * the reason on hover.
 */
const PassChip = ({ status, title }) => {
  const tone = status === "PASS" ? "ok" : status === "FAIL" ? "bad" : "quiet";
  return (
    <span className={`r4-pass r4-pass--${tone}`} title={title}>
      {tone !== "quiet" && (
        <span className="r4-pass__mark" aria-hidden="true">
          {tone === "ok" ? <CheckOutlined /> : <CloseOutlined />}
        </span>
      )}
      {status}
    </span>
  );
};

export default PassChip;
